"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _animations = require("@qc-modules/animations");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TabLink = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "tab__TabLink",
  componentId: "sc-wk1mn6-0"
})(["", ";text-decoration:none;position:relative;&:hover{color:", ";}"], (0, _styles.transitionEase)("0.25s", ["color"]), function (props) {
  return (0, _styles.colors)("blue", props);
});
var propTypes = {
  isActive: _propTypes.bool,
  onTabChangeEnd: _propTypes.func,
  onTabChangeStart: _propTypes.func,
  onTabClick: _propTypes.func,
  text: _propTypes.node.isRequired
};

var Tab = function Tab(_ref) {
  var text = _ref.text,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      onTabChangeEnd = _ref.onTabChangeEnd,
      onTabChangeStart = _ref.onTabChangeStart,
      onTabClick = _ref.onTabClick;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    "data-test-id": "modules-tab",
    flex: "0 0 auto",
    mr: 4,
    overflow: "auto",
    position: "relative"
  }, /*#__PURE__*/_react["default"].createElement(TabLink, {
    color: isActive ? "blue" : "body-grey",
    cursor: "pointer",
    display: "inline-block",
    fontSize: 4,
    letterSpacing: "0.5px",
    lineHeight: 2,
    onClick: onTabClick,
    pb: 3
  }, text), /*#__PURE__*/_react["default"].createElement(_animations.TransitionWidth, {
    alwaysShowInDom: false,
    enterDuration: 0.25,
    exitDuration: 0,
    fadeInOut: false,
    onEnterAnimationProperties: onTabChangeEnd ? {
      onComplete: onTabChangeEnd
    } : null,
    onExitAnimationProperties: onTabChangeStart ? {
      onStart: onTabChangeStart
    } : null,
    show: isActive
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    backgroundColor: "blue",
    bottom: 0,
    height: "3px",
    left: 0,
    position: "absolute",
    width: 1
  })));
};

Tab.propTypes = propTypes;
Tab.displayName = "Modules.Tab";
var _default = Tab;
exports["default"] = _default;